var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter" }, [
    _c("i", { staticClass: "fa fa-search" }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.Ifilter,
          expression: "Ifilter",
        },
      ],
      attrs: {
        type: "text",
        placeholder: _vm.$t("global.filter"),
        debounce: "500",
      },
      domProps: { value: _vm.Ifilter },
      on: {
        input: function ($event) {
          if ($event.target.composing) {
            return
          }
          _vm.Ifilter = $event.target.value
        },
      },
    }),
    _vm._v(" "),
    _c("i", {
      staticClass: "zmdi zmdi-close",
      class: { show: _vm.Ifilter.length > 0 },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.clearFilter($event)
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }